/* eslint-disable react/no-access-state-in-setstate */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component, Fragment, createRef } from 'react';
import '../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { connect } from 'react-redux';
import { AxiosError } from 'axios';

import { setFilterData, setFilterFlag } from '../actions/partiesActions';
import {
  getMatchByPath,
  getTimeIntervalForParty,
  getCurrentDate,
  isMobileResolution,
  trackMixpanel,
} from '../infrastructure/utils/common';
import { ItineraryList } from '../components/parties/ItineraryList';
import * as Service from '../services/PartiesService';
import * as OrdersService from '../services/OrdersService';
import Modal from '../components/utils/ModalComponet';
import Error from '../components/stateMessage/Error';
import TopPanel from '../components/utils/TopPanel';
import PartyDescription from '../components/parties/PartyDescription';
import MemberInfo from '../components/parties/MemberInfo/MemberInfo';
import Spinner from '../components/utils/Spinner';
import PartyOrdersList from '../components/orders/PartyOrdersList/PartyOrdersList';
import { EventForm } from '../components/forms/events/EventForm';
import TableSortingElem from '../infrastructure/TableSorting';
import Expenses from '../components/parties/Expenses/Expenses';
import {
  getAcceptedPartyMembers,
  getPartyMembersWithoutDuplicates,
} from '../infrastructure/utils/parties';
import PartySummary from '../components/parties/PartySummary';
import PartyBehavior from '../components/parties/PartyBehavior/PartyBehavior';
import PartyActiveSwitcher from '../components/parties/PartyActiveSwitcher';
import NoImage from '../NoImage.png';
// eslint-disable-next-line max-len
import PartyAddMemberModal from '../components/parties/PartyAddMemberModal/PartyAddMemberModal';
import * as UserService from '../services/UsersService';
import EventFormWrapper from '../components/forms/events/EventFormWrarpper';
import {
  fakeBachelorActivities,
  fakeBacheloretteActivities,
} from '../infrastructure/constants/events';
import CollapsableItem from '../components/utils/CollapsableItem';
import ItemActions from '../components/ItemActions/ItemActions';
import { getPartyActions } from '../infrastructure/constants/parties';
import AlertWrapper from '../components/utils/AlertWrapper';

class State {
  partyloaded = false;
  deactive = false;
  party = null;
  events = null;
  backPage = false;
  dates = null;
  openModal = false;
  modalContent = () => [];
  modalAction = undefined;
  actionButtonText = '';
  serverError = false;
  serverErrorMessage = '';
  code = null;
  addEvent = false;
  showEventInfo = false;
  activeEvents = [];
  eventType = '';
  typeForCreate = '';
  availableSort = [];
  activeSort = undefined;
  activityForEvent = undefined;
  admins = null;
  dayForAddingEvent = null;
  expenses = [];
  isAddMemberModalOpen = false;
  foundUsers = [];
  searchUsersSort = new TableSortingElem({ name: 'name', isString: true });
  isGuestAddingLoaded = false;
  bookMarked = [];
  polls = [];

  copyAlert?: string;
  copyAlertTimeoutId?: NodeJS.Timeout;
}

class Party extends Component {
  state = new State();

  constructor(props) {
    super(props);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.membersBlockRef = createRef();
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.eventsBlockRef = createRef();
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.ordersBlockRef = createRef();
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.expensesBlockRef = createRef();
  }

  async componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    try {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      if (history.length > 2) {
        this.setState({ backpage: true });
      }
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      const match = getMatchByPath(history.location.pathname, '/party/:id');
      const { id } = match.params;
      const [
        party,
        events,
        expenses,
        eventImages,
        orders,
        bookMarked,
        polls,
      ] = await Promise.all([
        Service.getParty(id),
        Service.getEventsByParty(id),
        Service.getExpensesByParty(id),
        Service.getDefaultImagesForEvent(),
        OrdersService.getOrdersByParty(
          id,
          new TableSortingElem({ name: 'totalPrice', isString: true })
        ),
        Service.getBookMarkedByPartyId(id),
        Service.getPollsByPartyId(id),
      ]);
      const { deactive } = this.state;
      const dates = getTimeIntervalForParty(party, events);
      if (!deactive) {
        const day = party.startDate
          ? party.startDate
          : getCurrentDate(new Date().toISOString(), party.tz);
        const { inviteCode: code } = party;
        this.setState({
          party,
          partyloaded: true,
          dates,
          events,
          expenses,
          code,
          orders,
          bookMarked,
          polls,
          availableSort: [
            new TableSortingElem({ name: 'totalPrice', isString: true }),
            new TableSortingElem({ name: 'status', isString: true }),
            new TableSortingElem({ name: 'created' }),
          ],
          activeSort: new TableSortingElem({
            name: 'totalPrice',
            isString: true,
          }),
          eventImages,
          dayForAddingEvent: day,
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.log(error.message);
    }
  }

  componentDidUpdate(_, prevState: Readonly<State>) {
    if (prevState.copyAlert !== this.state.copyAlert) {
      if (this.state.copyAlertTimeoutId) {
        clearTimeout(this.state.copyAlertTimeoutId);
        this.setState({ copyAlertTimeoutId: undefined });
      }

      if (this.state.copyAlert) {
        const timeout = setTimeout(() => {
          this.setState({ copyAlert: undefined });
        }, 2500);
        this.setState({ copyAlertTimeoutId: timeout });
      }
    }
  }

  componentWillUnmount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history, setFilter, activateFilter } = this.props;
    this.setState({ deactive: true });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (history.location.pathname !== '/') {
      activateFilter(false);
      setFilter(undefined);
    }
  }

  onEventClick = to => {
    const { party } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    history.push(`/party/${party.partyId}/event/${to}`);
  };

  back = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.goBack();
  };

  addTravelInfo = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderEventForm,
      typeForCreate: 'Flight',
      dayForAddingEvent: 'TBD',
    });
  };

  addAccommodationInfo = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderEventForm,
      typeForCreate: 'Lodging',
      dayForAddingEvent: 'TBD',
    });
  };

  addEvent = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderEventForm,
      typeForCreate: 'Event',
      dayForAddingEvent: 'TBD',
    });
  };

  addEventInDay = day => {
    this.setState({
      openModal: true,
      modalContent: this.renderEventForm,
      dayForAddingEvent: day,
      typeForCreate: 'Event',
    });
  };

  handleEventSubmit = async event => {
    const { events, party } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { currentUser, mixpanel } = this.props;
    const newEvent = {
      ...event,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      partyId: party.partyId,
    };
    try {
      const id = await Service.CreateEvent(newEvent);
      trackMixpanel(
        'itineraryEventCreated',
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        { partyId: party.partyId, eventId: id },
        currentUser,
        mixpanel
      );
      const eventWithId = {
        ...newEvent,
        eventId: id,
      };
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const newEvents = [...events, eventWithId];
      this.setState({
        openModal: false,
        activityForEvent: undefined,
        dates: getTimeIntervalForParty(party, newEvents),
        events: newEvents,
      });
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    }
  };

  changeSort = async name => {
    const { activeSort, availableSort, party } = this.state;
    let sort = null;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (activeSort.name === name) {
      sort = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...activeSort,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        up: !activeSort.up,
      };
      this.setState({ activeSort: sort });
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      sort = availableSort.find(s => s.name === name);
      this.setState({ activeSort: sort });
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const orders = await OrdersService.getOrdersByParty(party.partyId, sort);
    this.setState({ orders });
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  onOrderClick = order => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(order);
  };

  toUser = memberId => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(`/users/${memberId}`);
  };

  hideMessage = () => {
    this.setState({ serverError: false });
  };

  changeStatus = async (status: boolean) => {
    this.setState(prevState => {
      const party = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.party,
        partyStatus: status ? 'pending' : 'deactivated',
      };
      const newState = {
        ...prevState,
        party,
      };
      return newState;
    });
    const { party } = this.state;
    try {
      if (status) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        await Service.activateParty(party.partyId);
      } else {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        await Service.deactivateParty(party.partyId);
      }
    } catch (err) {
      this.setState({
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        party: { ...party, partyStatus: status ? 'deactivated' : 'pending' },
      });
    }
  };

  deleteMember = async (memberId, memberToAssign) => {
    const { party } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { currentUser, mixpanel } = this.props;
    try {
      await Service.removeMemberFromParty(
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        party.partyId,
        memberId,
        memberToAssign
      );
      trackMixpanel(
        'partyGuestRemoved',
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        { partyId: party.partyId, guestId: memberId },
        currentUser,
        mixpanel
      );
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    }
    this.setState(prevState => {
      const newpPrty = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.party,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        members: prevState.party.members.filter(
          member => member.memberId !== memberId
        ),
      };
      return { party: newpPrty };
    });
    // eslint-disable-next-line no-restricted-globals
    // eslint-disable-next-line no-undef
    location.reload();
  };

  getIdeasList = party => {
    if (party.gender === 'bride') {
      return fakeBacheloretteActivities;
    }
    if (party.gender === 'groom') {
      return fakeBachelorActivities;
    }
    return [...fakeBacheloretteActivities, ...fakeBachelorActivities];
  };

  renderEventForm = () => {
    const {
      party,
      dates,
      events,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      eventImages,
      typeForCreate,
      dayForAddingEvent,
      activityForEvent,
    } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const start = party.startDate
      ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        dates[0]
      : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        getCurrentDate(new Date().toISOString(), party.tz);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const end = party.endDate ? party.endDate : '';
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const partyLocation = party.partyLocation
      ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        party.partyLocation.address
      : '';
    return (
      <EventFormWrapper
        party={party}
        typeForCreate={typeForCreate}
        ideas={this.getIdeasList(party)}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        addEventToState={newEvent =>
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          this.setState({ events: [...events, newEvent] })
        }
        closeModal={() => this.setState({ openModal: false })}
      >
        <EventForm
          handleEventSubmit={this.handleEventSubmit}
          startDate={start}
          images={eventImages}
          typeForCreate={typeForCreate}
          partyLocation={partyLocation}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          tz={party.tz}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          offset={party.timeOffset}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          partyMembers={party.members.filter(member => !member.joinedAs)}
          endDate={end}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          dayForAdd={dayForAddingEvent}
          activityForEvent={activityForEvent}
        />
      </EventFormWrapper>
    );
  };

  loadUsers = async email => {
    const { searchUsersSort } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const foundUsers = await UserService.getAllUsers(
      searchUsersSort,
      { email },
      0
    );
    this.setState({ ...this.state, foundUsers });
  };

  onUsersSortChange = (name, emailValue) => {
    const { searchUsersSort } = this.state;
    const oldSortingValue = searchUsersSort;
    let newSortingValue;
    if (oldSortingValue.name === name) {
      newSortingValue = { ...oldSortingValue, up: !oldSortingValue.up };
    } else {
      newSortingValue = new TableSortingElem({ name, isString: true });
    }
    this.setState({ ...this.state, searchUsersSort: newSortingValue }, () =>
      this.loadUsers(emailValue)
    );
  };

  addGuest = async (party, user) => {
    const member = {
      memberId: user.id,
      memberName: user.name,
      memberEmail: user.email,
      partyId: party.partyId,
      memberRole: 'guest',
    };
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { currentUser, mixpanel } = this.props;
    try {
      this.setState({ ...this.state, isGuestAddingLoaded: true });
      await Service.updatePartyMember(member);
      trackMixpanel(
        'partyGuestAdded',
        { partyId: party.partyId, guestId: user.id },
        currentUser,
        mixpanel
      );
      // eslint-disable-next-line react/destructuring-assignment
      const clonedParty = JSON.parse(JSON.stringify(this.state.party));
      clonedParty.members.push(member);
      this.setState({ ...this.state, party: clonedParty });
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      console.error(e);
    } finally {
      this.setState({ ...this.state, isGuestAddingLoaded: false });
    }
  };

  render() {
    const {
      party,
      bookMarked,
      polls,
      events,
      dates,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      backpage,
      code,
      partyloaded,
      openModal,
      modalContent,
      modalAction,
      actionButtonText,
      serverError,
      serverErrorMessage,
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      orders,
      expenses,
      isAddMemberModalOpen,
      foundUsers,
      searchUsersSort,
      isGuestAddingLoaded,
      copyAlert,
    } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    if (!partyloaded) {
      return <Spinner />;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const status = party.partyStatus === 'deactivated';
    const membersWithoutDuplicates = getPartyMembersWithoutDuplicates(
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      party.members
    );
    const acceptedMembers = getAcceptedPartyMembers(membersWithoutDuplicates);
    const isExpanded = !isMobileResolution();
    return (
      <Fragment>
        <AlertWrapper show={!!copyAlert}>
          <p>{copyAlert}</p>
        </AlertWrapper>

        {serverError && <Error text={serverErrorMessage} />}
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
          action={modalAction}
          actionButtonText={actionButtonText}
        >
          {modalContent()}
        </Modal>
        <Modal
          open={isAddMemberModalOpen}
          closeModal={() =>
            this.setState({ ...this.state, isAddMemberModalOpen: false })
          }
          cancel={() =>
            this.setState({ ...this.state, isAddMemberModalOpen: false })
          }
          stylesProps={{ minHeight: '588px' }}
        >
          <PartyAddMemberModal
            party={party}
            loadUsers={this.loadUsers}
            users={foundUsers}
            setUsers={val => this.setState({ ...this.state, foundUsers: val })}
            searchUsersSort={searchUsersSort}
            onUsersSortChange={this.onUsersSortChange}
            addGuest={this.addGuest}
            isGuestAddingLoaded={isGuestAddingLoaded}
          />
        </Modal>
        <TopPanel isDetailsPage>
          <div
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            type='button'
            className='btn-nav back'
            onClick={backpage ? this.back : undefined}
            style={{ marginLeft: '15px' }}
            aria-label='left Align'
          >
            {backpage && (
              <>
                <i
                  className='fas fa-arrow-left'
                  style={{ paddingRight: '8px' }}
                />
                <span className='page-back'>Back</span>
              </>
            )}
            <span className='page-back-mobile'>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                party.partyName
              }
            </span>
          </div>
        </TopPanel>
        <div className='data-container'>
          <div className='data-box'>
            <div className='party-header'>
              <div
                className='party-image'
                style={{
                  display:
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    isMobileResolution && !party.picture ? 'none' : 'block',
                }}
              >
                <img
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  src={party.picture || NoImage}
                  onError={e => {
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    e.target.onerror = null;
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    e.target.src = NoImage;
                  }}
                  className='align-self-start mr-3'
                  alt=''
                />
              </div>
              <PartyDescription party={party} code={code} />
              <PartyActiveSwitcher
                party={party}
                changeStatus={this.changeStatus}
              />

              <ItemActions
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                actions={getPartyActions(party)}
                setCopyAlert={(copyAlert: string) =>
                  this.setState({ copyAlert })
                }
              />
            </div>
            <PartySummary
              membersCount={membersWithoutDuplicates.length}
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              eventsCount={events.length}
              draftOrdersCount={
                orders.filter(order => order.status === 'Draft').length
              }
              bachPurchasesCount={
                orders.filter(order => order.status !== 'Draft').length
              }
              expensesCount={expenses.length}
              ref={{
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                membersBlockRef: this.membersBlockRef,
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                eventsBlockRef: this.eventsBlockRef,
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                ordersBlockRef: this.ordersBlockRef,
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                expensesBlockRef: this.expensesBlockRef,
              }}
            />
          </div>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            party.members && (
              <div className='data-box'>
                <div className='members-top-part'>
                  <h4 className='header'>
                    Members
                    <span className='members-count'>
                      {`(${acceptedMembers.length} of
                      ${membersWithoutDuplicates.length} joined)`}
                    </span>
                  </h4>
                  <button
                    type='button'
                    className='btn btn-def'
                    onClick={() =>
                      this.setState({
                        ...this.state,
                        isAddMemberModalOpen: true,
                      })
                    }
                  >
                    <span>+</span> Add Info
                  </button>
                </div>
                <CollapsableItem
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  ref={this.membersBlockRef}
                  isExpanded={isExpanded}
                >
                  <MemberInfo
                    members={membersWithoutDuplicates}
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    creator={party.userId}
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    status={party.partyStatus}
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    party={party.partyId}
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    partyTz={party.tz}
                    toUser={this.toUser}
                    deleteMember={this.deleteMember}
                  />
                </CollapsableItem>
              </div>
            )
          }
          {expenses && (
            <div className='data-box'>
              <h4 className='header'>Expenses</h4>
              <CollapsableItem
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                ref={this.expensesBlockRef}
                isExpanded={isExpanded}
              >
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  <Expenses expenses={expenses} />
                }
              </CollapsableItem>
            </div>
          )}
          <ItineraryList
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            content={events}
            dates={dates}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            startTime={dates[0]}
            status={status}
            addTravelInfo={this.addTravelInfo}
            addAccommodationInfo={this.addAccommodationInfo}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            endTime={dates[dates.length - 1]}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            partyTz={party.tz}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            members={party.members}
            onEventClick={this.onEventClick}
            addEvent={this.addEvent}
            addEventInDay={this.addEventInDay}
            refs={{
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              eventsBlockRef: this.eventsBlockRef,
            }}
            isExpanded={isExpanded}
          />

          <PartyBehavior
            bookMarked={bookMarked}
            polls={polls}
            history={history}
            isExpanded={isExpanded}
          />
          {orders.length > 0 && (
            <div className='data-box'>
              <h4 className='header'>Orders</h4>
              <CollapsableItem
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                ref={this.ordersBlockRef}
                isExpanded={isExpanded}
              >
                <PartyOrdersList
                  orders={orders}
                  changeSort={this.changeSort}
                  activeSort={activeSort}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  party={party}
                  handleOnClick={this.onOrderClick}
                />
              </CollapsableItem>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.users.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Party);
